// extracted by mini-css-extract-plugin
export default {"firstsliding":"autoslider_firstsliding__kwUy3","firstslidetrack":"autoslider_firstslidetrack__0BUMM","scroll":"autoslider_scroll__DZMCh","firstslide":"autoslider_firstslide__OpNVc"};